const defaults = {
  APP_AUTHOR: 'X Studios, Inc.',
  APP_ISSUES_URL: '',
  APP_LICENSE: 'Proprietary',
  APP_NAME: 'Xapp',
  APP_VERSION: '0.1.0',
}

export let APP_AUTHOR = defaults.APP_AUTHOR
export let APP_NAME = defaults.APP_NAME
export let APP_VERSION = defaults.APP_VERSION
export let APP_LICENSE = defaults.APP_LICENSE
export let APP_ISSUES_URL = defaults.APP_ISSUES_URL

export function setXappCoreAppMeta(meta = {}) {
  APP_AUTHOR = meta.APP_AUTHOR || defaults.APP_AUTHOR
  APP_NAME = meta.APP_NAME || defaults.APP_NAME
  APP_VERSION = meta.APP_VERSION || defaults.APP_VERSION
  APP_LICENSE = meta.APP_LICENSE || defaults.APP_LICENSE
  APP_ISSUES_URL = meta.APP_ISSUES_URL || defaults.APP_ISSUES_URL
}
